import React from 'react';
import withSounds from 'containers/withSounds';
import { isAdmin } from 'utils/roles';
import { userShape } from 'utils/shapes';

function HeaderAdminLink({ user, ...otherProps }) {
  return user && isAdmin(user) ? (
    <li role="presentation">
      <a
        href="/admin/"
        rel="noopener noreferrer"
        role="menuitem"
        {...otherProps}
      >
        Admin
      </a>
    </li>
  ) : null;
}

HeaderAdminLink.propTypes = {
  user: userShape
};

export default withSounds({ mouseEnterSound: true })(HeaderAdminLink);
